import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { Link, NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useContext, useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { deleteTags as deleteTagFromStore } from '../../../redux/slices/tagsSlice';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'
// Redux imports (optional, if you want to store in redux)
// import { useDispatch } from 'react-redux';
// import { setBranches } from '../../redux/slices/branchSlice';

export default function LenderList() {
  const [lenderList, setLenderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [searchName, setSearchName] = useState('');
  const authCtx = useContext(AuthContext);

  // Debounce ref
  const debounceRef = useRef();
  const dispatch = useDispatch();

  // Fetch branches API
 const fetchLenderPanles = async (searchNameVal, pageVal = page) => {
  setLoading(true);
  try 
    {
    const payload = {
      page: pageVal,
      limit: 10,
      search: searchNameVal,
    };

    const response = await postRequest('private/lenderPanelList', payload, authCtx.token);
    console.log(response , 'response@123')
    if (response?.status === 200 && response?.data) {
      setLenderList(response.data.docs || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalDocs(response.data.totalDocs || 0);
    } else {
      setLenderList([]);
      setTotalPages(1);
      setTotalDocs(0);
    }
  } catch (err) {
    setLenderList([]);
    setTotalPages(1);
    setTotalDocs(0);
  }
  setLoading(false);
};

  // Fetch on mount and when page changes
  useEffect(() => {
    fetchLenderPanles(searchName, page);
    // eslint-disable-next-line
  }, [page, authCtx.token]);

  // Debounced search on name or postcode change
  useEffect(() => {
    setPage(1); // Reset to first page on search
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchLenderPanles(searchName, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchName]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };


  const handleDeleteLenderPanel = async (id) => {
  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you really want to delete this lender panel?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#bb0000',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirm.isConfirmed) {
    try {
      const response = await postRequest(`private/deleteLenderPanel/${id}`, {}, authCtx.token); // use POST or DELETE depending on backend
      if (response?.status === 200) {
      
        Swal.fire('Deleted!', response.message || 'Lender panel has been deleted.', 'success');
         const isLastItemOnPage = lenderList.length === 1 && page > 1;

        fetchLenderPanles(searchName, isLastItemOnPage ? page - 1 : page);
        //fetchLenderPanles(searchName, page);
      } else {
        Swal.fire('Error', response.message || 'Something went wrong', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Something went wrong', 'error');
    }
  }
};


  const handleToggleStatus = async (id) => {
    try {
      const response = await postRequest(`private/lenderPanelStatus/${id}`, {}, authCtx.token);
      if (response?.status === 200) {
        Swal.fire('Success', response?.message || 'Status updated', 'success');
        fetchLenderPanles(searchName, page); 
      } else {
        Swal.fire('Error', response?.message || 'Something went wrong', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Something went wrong', 'error');
    }
  };

  return (
    <>
         <BreadcrumbsWrapper
                                                    items={[
                                                      { label: 'Dashboard', path: '/dashboard' },
                                                      { label: 'LenderPanles', path: '' },
                                                    ]}
                                                  />
                                            <br></br>
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Lender Panels</h1>
        <div className='header-right-btn'>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/lenderPanels/create" className="red-link-text">
                <PersonAddOutlinedIcon /> &nbsp; Add Lender Panel
              </NavLink>
            </Button>
          </Stack>
        </div>
      </div>
      <div className='page-top-formview mb-3'>
        <Form>
          <Row className="mb-3">
            <Form.Group fullWidth controlId="searchUsername">
<FormGroup>
                <TextField id="outlined-basic" label="Search Name" variant="outlined" 
                value={searchName}
                onChange={e => {
                  setSearchName(e.target.value);
                  setPage(1); 
                  }}
                  /> 
                  </FormGroup>

              {/* <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchName}
                onChange={e => {
                  setSearchName(e.target.value);
                  setPage(1);
                }}
              /> */}
            </Form.Group>
          </Row>
        </Form>
      </div>

      <div>
        <Table striped responsive bordered>
          <thead>
            <tr>

              <th>Lenders Name</th>
              <th>Lender Number</th>
              <th>Working with panel?</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center' }}>
                  <CircularProgress size={28} />
                </td>
              </tr>
            ) : lenderList.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center' }}>
                  No lender panel found.
                </td>
              </tr>
            ) : (
              lenderList.map((tag) => (
                <tr key={tag._id}>
                  <th>{tag?.name}</th>
                  <td>
                    {tag?.lender_numbers && tag.lender_numbers.length > 0
                      ? tag.lender_numbers.join(', ')
                      : '-'}
                  </td>
                   <td>
                     <Switch
                       checked={tag?.isActive}
                       onChange={() => handleToggleStatus(tag._id)}
                       color="primary"
                     />
                     {tag?.isActive ? "Enabled" : "Disabled"}
                   </td>

                   <td>
          <span
            className='red-link-text cursor-pointer w-18'
            title="Edit"
            style={{ marginRight: 8 }}
          >
            <NavLink to={`/lenderPanels/edit/${tag._id}`} className="red-link-text">
              <EditOutlinedIcon />
            </NavLink>
          </span>
          <span
            className="red-link-text cursor-pointer w-18"
            title="Delete"
            onClick={() => handleDeleteLenderPanel(tag._id)}
          >
            <DeleteOutlineOutlinedIcon />
          </span>
        </td>
                
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {/* Pagination */}
      {lenderList.length > 0 && (
  <>
    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 8, marginBottom: 8 }}>
      <span className="text-muted small">
        Showing {((page - 1) * 10) + 1}-{Math.min(page * 10, totalDocs)} of {totalDocs} lender panels
      </span>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        shape="rounded"
        size="medium"
        sx={{
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                    color: '#fff !important',
                  },
                  '& .MuiPaginationItem-root': {
                    color: 'var(--bs-red-color)',
                    borderColor: 'var(--bs-red-color)',
                  },
                }}
      />
    </div>
  </>
)}

      </div>
    </>
  );
}